/** @tossdocs-ignore */
function isNonEmptyArray(array) {
  return array.length >= 1;
}

export { isNonEmptyArray };
